import { useBlockInteractionContext } from '../../components/organisms/BlockInteractions/BlockInteractionContext';
import { useRefreshBlock } from './useRefreshBlock';

export function useRefreshBlockInDefaultView() {
  const { refresh } = useRefreshBlock();

  const { switchToDefaultView } = useBlockInteractionContext();

  return {
    refresh: () => {
      refresh();
      switchToDefaultView();
    },
  };
}
